<template>
  <div class="quotationCustomerDiscountDetail">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <div class="title" v-if="pageType == 'add'">{{ $t.onlineOrder.addPrice }}</div>
      <div class="title" v-if="pageType == 'edit'">{{ $t.onlineOrder.editPrice }}</div>
      <div class="title" v-if="pageType == 'batch'">{{ $t.onlineOrder.batchPrice }}</div>

      <van-field
        v-model="form.CustomerName"
        :label="$t.onlineOrder.customerName"
        :placeholder="$t.meta.input"
        @click="onShowEmit('showQuotationCustomerDiscountCustomer')"
        clickable
        required
        :rules="formRule"
        readonly
        type="textarea"
      />

      <div class="title" v-if="pageType != 'batch'">{{ $t.onlineOrder.batchPrice }}</div>

      <van-field
        v-model="batchDiscountTypeStr"
        :label="$t.onlineOrder.discountType"
        :placeholder="$t.meta.select"
        :required="pageType == 'batch' ? true : false"
        :rules="pageType == 'batch' ? formRule : null"
        clickable
        readonly
        @click="pickerShow(0, 'showQuotationCustomerDiscountDetailDiscountType')"
      />

      <van-field
        v-model="batchDiscountValue"
        :label="
          batchDiscountType == 2
            ? $t.onlineOrder.discountAmount
            : $t.onlineOrder.discountRate + '(%)'
        "
        :label-class="pageType == 'batch' ? '' : 'number-label'"
        :placeholder="$t.meta.input"
        :required="pageType == 'batch' ? true : false"
        :rules="pageType == 'batch' ? formRule : null"
        v-if="batchDiscountType"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            native-type="button"
            @click="batchPriceChange"
            v-if="pageType != 'batch'"
            >{{ $t.meta.confirm }}</van-button
          >
        </template>
      </van-field>

      <div class="multi-table" v-if="form.DiscountList">
        <div v-for="(item, index) in form.DiscountList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
          </div>

          <van-field
            v-model="item.CargoCategory"
            :label="$t.onlineOrder.cargoCategory"
            disabled
          />

          <van-field
            v-model="item.FirstWeightPrice"
            :label="$t.onlineOrder.firstWeightPrice"
            disabled
          />

          <van-field
            v-model="item.ContinuousWeightPrice"
            :label="$t.onlineOrder.continuePrice"
            disabled
          />

          <van-field v-model="item.CurrencySn" :label="$t.meta.currency" disabled />

          <van-field
            v-model="item.DiscountTypeStr"
            :label="$t.onlineOrder.discountType"
            @click="pickerShow(index, 'showDiscountTypePicker')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
            :rules="formRule"
          />

          <van-field
            v-model="item.DiscountRate"
            :label="$t.onlineOrder.discountRate + '(%)'"
            :placeholder="$t.meta.input"
            required
            :rules="formRule"
            v-if="item.DiscountType == 1"
          />

          <van-field
            v-model="item.DiscountAmount"
            :label="$t.onlineOrder.discountAmount"
            :placeholder="$t.meta.input"
            required
            :rules="formRule"
            v-if="item.DiscountType == 2"
          />
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <fetch-list
      event="showQuotationCustomerDiscountCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>

    <van-popup
      v-model="showQuotationCustomerDiscountDetailDiscountType"
      round
      position="bottom"
    >
      <van-picker
        :title="$t.onlineOrder.discountType"
        show-toolbar
        :columns="discountTypeOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="discountTypeBatchConfirm($event)"
        @cancel="showQuotationCustomerDiscountDetailDiscountType = false"
      />
    </van-popup>

    <van-popup v-model="showDiscountTypePicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.discountType"
        show-toolbar
        :columns="discountTypeOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="discountTypeConfirm($event)"
        @cancel="showDiscountTypePicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import FetchList from "@components/fetchList/FetchList.vue";
import Vue from "vue";
import { Form, Field, Button, Picker, Popup } from "vant";

Vue.use(Form).use(Field).use(Button).use(Picker).use(Popup);

export default {
  name: "quotationCustomerDiscountDetail",
  components: {
    FetchList,
  },
  data() {
    return {
      pageType: "",
      FPId: "",
      CustomerId: null,
      batchDiscountType: null,
      batchDiscountTypeStr: "",
      batchDiscountValue: "",
      form: {
        FPId: null,
        CustomerName: "",
        CustomerId: null,
        DiscountList: [],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      //picker
      showQuotationCustomerDiscountDetailDiscountType: false,
      discountTypeOptions: [
        {
          text: this.$t.onlineOrder.discountType1,
          value: 1,
        },
        {
          text: this.$t.onlineOrder.discountType2,
          value: 2,
        },
      ],
      showDiscountTypePicker: false,
      itemIndex: 0,
    };
  },
  created() {
    const { FPId, Type, CustomerName, CustomerId } = this.$route.query;
    this.pageType = Type;
    if (FPId) {
      this.FPId = FPId;
      this.form.CustomerName = CustomerName;
      this.form.CustomerId = CustomerId;
      this.loadFreightPriceCustomerDiscountInfo();
    }
  },
  methods: {
    batchPriceChange() {
      for (var discountList of this.form.DiscountList) {
        discountList.DiscountTypeStr = this.batchDiscountTypeStr;
        discountList.DiscountType = this.batchDiscountType;
        if (discountList.DiscountType == 1) {
          discountList.DiscountRate = this.batchDiscountValue;
        }
        if (discountList.DiscountType == 2) {
          discountList.DiscountAmount = this.batchDiscountValue;
        }
      }
    },
    loadFreightPriceCustomerDiscountInfo() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.onlineOrderManagement
          .loadFreightPriceCustomerDiscountInfo({
            FPId: this.FPId,
            CustomerId: this.form.CustomerId,
          })
          .then((res) => {
            this.form.DiscountList = res.data.DiscountList;
            for (var item of this.form.DiscountList) {
              if (this.pageType == "add") {
                item.DiscountRate = null;
                item.DiscountAmount = "";
              }
              //优惠类型
              if (item.DiscountType) {
                var discountType = this.discountTypeOptions.find(
                  (c) => c.value == item.DiscountType
                );
                if (discountType) {
                  item.DiscountTypeStr = discountType.text;
                }
              }
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSelectCustomer(item) {
      this.form.CustomerName = item.text;
      this.form.CustomerId = item.value;
      this.$forceUpdate();
    },
    discountTypeBatchConfirm(e) {
      this.batchDiscountTypeStr = e.text;
      this.batchDiscountType = e.value;
      this.showQuotationCustomerDiscountDetailDiscountType = false;
    },
    discountTypeConfirm(e) {
      this.form.DiscountList[this.itemIndex].DiscountTypeStr = e.text;
      this.form.DiscountList[this.itemIndex].DiscountType = e.value;
      this.showDiscountTypePicker = false;
    },
    pickerShow(index, pickerName) {
      this[pickerName] = true;
      this.itemIndex = index;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.FPId = this.FPId;
      var request = null;
      if (this.pageType == "batch") {
        param.DiscountType = this.batchDiscountType;
        if (this.batchDiscountType == 1) {
          param.DiscountRate = this.batchDiscountValue;
        }
        if (this.batchDiscountType == 2) {
          param.DiscountAmount = this.batchDiscountValue;
        }
        request = this.$api.onlineOrderManagement.batchAddFreightPriceCustomerDiscount(
          param
        );
      } else {
        request = this.$api.onlineOrderManagement.addFreightPriceCustomerDiscount(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.quotationCustomerDiscountDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .quotationCustomerDiscountDetail-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
      display: inline-flex;
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      background: #1e90ff;
      .multi-table-title {
        font-size: 14px;
        font-family: monospace;
        color: #fff;
        width: 50%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        width: 50%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
        .van-icon {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
        }
      }
    }
  }
}
</style>
